/*
 * The `currency` formatter.
 *
 * Lifted out of `vue2-filters` and kept byte-for-byte in behaviour (including the thousands
 * separator and the `$1,234.00` shape), because it is the money path: the on-screen quote, the
 * job-information panel and the generated PDF all format money with it.
 *
 * Vue 3 removes filters. This is registered as a global filter with `app.filter('currency', …)` in
 * the entry - the compat build still supports filters, so the templates keep `{{ x | currency('$', 0) }}`
 * - and called directly from `quoteSection.js`, which renders the PDF outside a component.
 *
 * Defaults match vue2-filters: `$` and 2 decimals.
 */
const digitsRE = /(\d{3})(?=\d)/g

function toFixed(num, precision) {
  return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision)
}

export default function currency(value, symbol, decimals) {
  symbol = typeof symbol !== 'undefined' ? symbol : '$'
  decimals = typeof decimals !== 'undefined' ? decimals : 2
  const thousandsSeparator = ','
  const symbolOnLeft = true
  const spaceBetweenAmountAndSymbol = false
  const showPlusSign = false

  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) {
    return ''
  }

  const number = Math.abs(value)
  let stringified = toFixed(number, decimals)
  const _int = decimals ? stringified.slice(0, -1 - decimals) : stringified
  const i = _int.length % 3
  const head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? thousandsSeparator : '') : ''
  const _float = decimals ? stringified.slice(-1 - decimals) : ''
  symbol = spaceBetweenAmountAndSymbol ? (symbolOnLeft ? symbol + ' ' : ' ' + symbol) : symbol
  symbol = symbolOnLeft
    ? symbol + head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float
    : head + _int.slice(i).replace(digitsRE, '$1' + thousandsSeparator) + _float + symbol
  const sign = value < 0 ? '-' : ''
  const plusSign = value > 0 && showPlusSign ? '+' : ''

  return plusSign + sign + symbol
}
